export default __webpack_public_path__ + "static/bg-2a3d58e6df431debb0e6246011da4dbd.png";